import SessionTableAnnotation from './SessionTableAnnotation';

export default SessionTableAnnotation;
